module.exports = __webpack_public_path__ + "img/LogoLight.c7f82bc6.svg";